import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import lipumetricas from '../assets/images/lipumetricasmty.png';
import infobag from '../assets/images/infobag.png';
import finops from '../assets/images/finops.png';
import compensaciones from '../assets/images/compensaciones_web.png';
import brainNotes from '../assets/images/brain-notes.png';
import taqueria from '../assets/images/taqueriaSPA.png';
import punchdata from '../assets/images/punchData.png';
import { FaExternalLinkAlt } from 'react-icons/fa';

const Projects = () => {
  const { t } = useTranslation();
  const [hoveredId, setHoveredId] = useState(null);

  const projects = [
    {
      id: 1,
      name: t('projects.finops.name'),
      description: t('projects.finops.description'),
      link: 'https://www.finops.org/',
      image: finops,
      technologies: ['React', 'Node.js', 'Vite', 'MongoDB'],
      category: t('projects.finops.category')
    },
    {
      id: 4,
      name: t('projects.brainNotes.name'),
      description: t('projects.brainNotes.description'),
      link: 'https://github.com/YeraldoCode/brain-notes',
      image: brainNotes,
      technologies: ['Tauri', 'React', 'Gemini AI', 'Rust'],
      category: t('projects.brainNotes.category')
    },
    {
      id: 2,
      name: t('projects.lipu.name'),
      description: t('projects.lipu.description'),
      link: 'https://lipumtymetricas.com/',
      image: lipumetricas,
      technologies: ['Flask', 'Python', 'Chart.js', 'SQL'],
      category: t('projects.lipu.category')
    },
    {
      id: 3,
      name: t('projects.infobag.name'),
      description: t('projects.infobag.description'),
      link: 'https://github.com/YeraldoCode/InfoBag',
      image: infobag,
      technologies: ['Python', 'Tkinter', 'APIs', 'Pandas'],
      category: t('projects.infobag.category')
    },
    {
      id: 6,
      name: t('projects.compensaciones.name'),
      description: t('projects.compensaciones.description'),
      link: 'https://github.com/YeraldoCode/compensaciones_web',
      image: compensaciones,
      technologies: ['Flask', 'Bootstrap', 'JavaScript', 'Excel'],
      category: t('projects.compensaciones.category')
    },
    {
      id: 8,
      name: t('projects.punchdata.name'),
      description: t('projects.punchdata.description'),
      link: 'https://punchdata.online/',
      image: punchdata,
      technologies: ['React', 'Node.js', 'Vite', 'Firebase', 'Puppeteer'],
      category: t('projects.punchdata.category')
    },
    {
      id: 7,
      name: t('projects.taqueria.name'),
      description: t('projects.taqueria.description'),
      link: 'https://sabormexicano-8dcb9.web.app/',
      image: taqueria,
      technologies: ['React', 'CSS', 'Vite', 'Firebase'],
      category: t('projects.taqueria.category')
    }
  ];

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 1
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 1
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1
    }
  };

  const CustomButtonGroup = ({ next, previous }) => {
    return (
      <div style={{
        position: 'absolute',
        top: '50%',
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        transform: 'translateY(-50%)',
        pointerEvents: 'none',
        zIndex: 10
      }}>
        <button
          onClick={previous}
          style={{
            pointerEvents: 'all',
            background: '#cc0033',
            border: 'none',
            borderRadius: '50%',
            width: '50px',
            height: '50px',
            color: 'white',
            fontSize: '1.5rem',
            cursor: 'pointer',
            marginLeft: '10px',
            boxShadow: '0 4px 12px rgba(204, 0, 51, 0.3)',
            transition: 'all 0.3s ease'
          }}
          onMouseEnter={(e) => {
            e.target.style.background = '#a60029';
            e.target.style.transform = 'scale(1.1)';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = '#cc0033';
            e.target.style.transform = 'scale(1)';
          }}
        >
          ‹
        </button>
        <button
          onClick={next}
          style={{
            pointerEvents: 'all',
            background: '#cc0033',
            border: 'none',
            borderRadius: '50%',
            width: '50px',
            height: '50px',
            color: 'white',
            fontSize: '1.5rem',
            cursor: 'pointer',
            marginRight: '10px',
            boxShadow: '0 4px 12px rgba(204, 0, 51, 0.3)',
            transition: 'all 0.3s ease'
          }}
          onMouseEnter={(e) => {
            e.target.style.background = '#a60029';
            e.target.style.transform = 'scale(1.1)';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = '#cc0033';
            e.target.style.transform = 'scale(1)';
          }}
        >
          ›
        </button>
      </div>
    );
  };

  return (
    <section
      id="projects"
      style={{
        background: 'linear-gradient(135deg, #1a1a1a 0%, #000000 100%)',
        padding: '80px 20px',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      <div className="container" style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-5"
        >
          <div
            style={{
              background: '#cc0033',
              color: 'white',
              padding: '8px 20px',
              fontSize: '0.85rem',
              fontWeight: '600',
              letterSpacing: '2px',
              textTransform: 'uppercase',
              marginBottom: '30px',
              display: 'inline-block'
            }}
          >
            {t('projects.tag')}
          </div>

          <h2
            style={{
              fontSize: '2.5rem',
              fontWeight: '700',
              color: 'white',
              marginBottom: '20px',
              fontFamily: 'Montserrat, sans-serif'
            }}
          >
            {t('projects.title')}
          </h2>

          <p
            style={{
              fontSize: '1.05rem',
              color: '#ccc',
              maxWidth: '800px',
              margin: '0 auto 50px'
            }}
          >
            {t('projects.subtitle')}
          </p>
        </motion.div>

        <div style={{ position: 'relative' }}>
          <Carousel
            responsive={responsive}
            infinite={true}
            autoPlay={true}
            autoPlaySpeed={4000}
            keyBoardControl={true}
            customTransition="transform 500ms ease-in-out"
            transitionDuration={500}
            containerClass="carousel-container"
            removeArrowOnDeviceType={[]}
            arrows={false}
            renderButtonGroupOutside={true}
            customButtonGroup={<CustomButtonGroup />}
            dotListClass="custom-dot-list-style"
            itemClass="carousel-item-padding-40-px"
            showDots={true}
          >
            {projects.map((project) => (
              <motion.div
                key={project.id}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
                viewport={{ once: true }}
                onMouseEnter={() => setHoveredId(project.id)}
                onMouseLeave={() => setHoveredId(null)}
                style={{
                  margin: '0 15px',
                  background: 'rgba(255, 255, 255, 0.05)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  transition: 'all 0.3s ease',
                  transform: hoveredId === project.id ? 'translateY(-10px)' : 'translateY(0)',
                  boxShadow: hoveredId === project.id
                    ? '0 12px 30px rgba(204, 0, 51, 0.3)'
                    : '0 4px 12px rgba(0, 0, 0, 0.3)'
                }}
              >
                <div style={{ position: 'relative', overflow: 'hidden', height: '250px' }}>
                  <img
                    src={project.image}
                    alt={project.name}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      transition: 'transform 0.3s ease',
                      transform: hoveredId === project.id ? 'scale(1.1)' : 'scale(1)'
                    }}
                  />
                  <div
                    style={{
                      position: 'absolute',
                      top: '15px',
                      right: '15px',
                      background: '#cc0033',
                      color: 'white',
                      padding: '6px 14px',
                      borderRadius: '20px',
                      fontSize: '0.75rem',
                      fontWeight: '600'
                    }}
                  >
                    {project.category}
                  </div>
                </div>

                <div style={{ padding: '25px' }}>
                  <h5
                    style={{
                      fontSize: '1.3rem',
                      fontWeight: '700',
                      color: 'white',
                      marginBottom: '12px',
                      fontFamily: 'Montserrat, sans-serif'
                    }}
                  >
                    {project.name}
                  </h5>

                  <p
                    style={{
                      fontSize: '0.9rem',
                      color: '#aaa',
                      lineHeight: '1.6',
                      marginBottom: '20px',
                      minHeight: '80px'
                    }}
                  >
                    {project.description}
                  </p>

                  <div
                    style={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      gap: '8px',
                      marginBottom: '20px'
                    }}
                  >
                    {project.technologies.map((tech, idx) => (
                      <span
                        key={idx}
                        style={{
                          padding: '5px 12px',
                          fontSize: '0.7rem',
                          fontWeight: '600',
                          borderRadius: '15px',
                          background: 'rgba(204, 0, 51, 0.15)',
                          color: '#ff6b6b',
                          border: '1px solid rgba(204, 0, 51, 0.3)'
                        }}
                      >
                        {tech}
                      </span>
                    ))}
                  </div>

                  <div style={{ display: 'flex', gap: '10px' }}>
                    <a
                      href={project.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        flex: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px',
                        padding: '10px',
                        background: 'linear-gradient(135deg, #cc0033 0%, #a60029 100%)',
                        color: 'white',
                        textDecoration: 'none',
                        borderRadius: '6px',
                        fontSize: '0.85rem',
                        fontWeight: '600',
                        transition: 'all 0.3s ease',
                        boxShadow: '0 4px 12px rgba(204, 0, 51, 0.3)'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = 'translateY(-2px)';
                        e.target.style.boxShadow = '0 6px 16px rgba(204, 0, 51, 0.4)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = '0 4px 12px rgba(204, 0, 51, 0.3)';
                      }}
                    >
                      <FaExternalLinkAlt size={14} />
                      {t('projects.viewProject')}
                    </a>
                  </div>
                </div>
              </motion.div>
            ))}
          </Carousel>
        </div>

        <style>{`
          .custom-dot-list-style {
            bottom: -50px !important;
            display: flex !important;
            justify-content: center !important;
            gap: 10px !important;
          }
          .custom-dot-list-style button {
            width: 12px !important;
            height: 12px !important;
            border-radius: 50% !important;
            border: 2px solid #cc0033 !important;
            background: transparent !important;
            transition: all 0.3s ease !important;
          }
          .custom-dot-list-style button.react-multi-carousel-dot--active {
            background: #cc0033 !important;
            transform: scale(1.3) !important;
          }
        `}</style>
      </div>
    </section>
  );
};

export default Projects;